import React, { useContext } from "react";
import { BrowserRouter as Router, Switch, Route, BrowserRouter,Redirect } from 'react-router-dom';
import pMinDelay from 'p-min-delay';
import { AuthContext } from "./context/AuthContext";

import loadable from './component/Common/loader/loadable';
import Loading from './component/Common/loader';
import Header from "./component/Common/Header";
import Footer from "./component/Common/Footer";
import ScrollToTop from './component/Common/ScrollToTop'
import Login from './page/login'
import Register from './page/register'
import Pharmacy from "./page/pharmacy";
import ShopLeftSideBar from './page/shop/shop-left-sidebar'
import Doctors from "./page/doctors";
import Departments from "./page/departments";
import About from "./page/about";
import ProductDetails from './page/product/index'
import DepartmentDetails from './component/Common/DepartmentDetails/DepartmentDetails'
import CartThree from './page/cart/cart-three'
import ProductDetailsTwos from './page/product/product-details-two'
import PrivacyPolicy from './page/privacy-policy'
import ContactTwo from './page/contact/contact-two'
import Faqs from './page/faqs'
import Appointments from './page/appointments/index'
import Profile from "./page/profile";
import Giftcards from "./page/giftcards";
import Results from "./page/results";
import Blogs from "./page/blogs";
import ResultDetails from "./component/Common/ProductDetails/ResultDetails";
import BlogDetails from "./component/Common/ProductDetails/BlogDetails";
// All Page Lazy Import


const ShopGrid = loadable(() => pMinDelay(import('./page/shop'), 250), { fallback: <Loading /> });
const Cart = loadable(() => pMinDelay(import('./page/cart/index'), 250), { fallback: <Loading /> });
const CartTwo = loadable(() => pMinDelay(import('./page/cart/cart-two'), 250), { fallback: <Loading /> });
const EmptyCarts = loadable(() => pMinDelay(import('./page/cart/empty-cart'), 250), { fallback: <Loading /> });
const CheckoutOne = loadable(() => pMinDelay(import('./page/checkout/index'), 250), { fallback: <Loading /> });
const CheckoutTwos = loadable(() => pMinDelay(import('./page/checkout/checkout-two'), 250), { fallback: <Loading /> });
const WishLists = loadable(() => pMinDelay(import('./page/shop/wishList'), 250), { fallback: <Loading /> });

const OrderComplete = loadable(() => pMinDelay(import('./page/order/order-complete'), 250), { fallback: <Loading /> });
const OrderTracking = loadable(() => pMinDelay(import('./page/order/order-tracking'), 250), { fallback: <Loading /> });

const BlogGridTwos = loadable(() => pMinDelay(import('./page/blog/'), 250), { fallback: <Loading /> });

const BlogSingleOnes = loadable(() => pMinDelay(import('./page/blog/blog-single-one'), 250), { fallback: <Loading /> });

const MyAccounts = loadable(() => pMinDelay(import('./page/my-account'), 250), { fallback: <Loading /> });
const CustomerOrder = loadable(() => pMinDelay(import('./page/my-account/customer-order'), 250), { fallback: <Loading /> });
const CustomerDownloads = loadable(() => pMinDelay(import('./page/my-account/customer-downloads'), 250), { fallback: <Loading /> });
const CustomerAddress = loadable(() => pMinDelay(import('./page/my-account/customer-address'), 250), { fallback: <Loading /> });
const CustomerAccountDetails = loadable(() => pMinDelay(import('./page/my-account/customer-account-details'), 250), { fallback: <Loading /> });
const AccountEdit = loadable(() => pMinDelay(import('./page/vendor/account-edit'), 250), { fallback: <Loading /> });

const Error = loadable(() => pMinDelay(import('./page/error'), 250), { fallback: <Loading /> });


  // #######################################################################



  /* function PublicRoute({ component: Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated() ? (
            <Redirect to={{ pathname: "/" }} />
          ) : (
            <Component {...props} /> 
          )
        }
      />
    );
  } */

  export default function App() {
  let { isAuthenticated } = useContext(AuthContext)

  return (
    <>
      <BrowserRouter>
        <Router>
          <Header />
          <ScrollToTop />
          <Switch>
            <Route path='/' exact component={Pharmacy} />

            <Route path='/treatments/:title/:id' exact component={ProductDetails} />
            <Route path='/result-details/:id' exact component={ResultDetails} />
            <Route path='/blog-details/:title/:id' exact component={BlogDetails} />
            <Route path='/doctor-details/:title/:id' exact component={ProductDetailsTwos} /> 
            <Route path='/department-details/:title/:id' exact component={DepartmentDetails} />
            <Route path='/cart' exact component={Cart} />
            <Route path='/cartTwo' exact component={CartTwo} />
            <Route path='/cartThree' exact component={CartThree} />
            <Route path='/estore' exact component={ShopLeftSideBar} />
            <Route path='/about' exact component={About} />
           <Route path='/doctors' exact component={Doctors} />
           <Route path='/giftcards' exact component={Giftcards} />
           <Route path='/departments' exact component={Departments} />
           <Route path='/before-after' exact component={Results} />
           <Route path='/blogs' exact component={Blogs} />
           <Route path='/blog-single-one' exact component={BlogSingleOnes} />
            <Route path='/privacy-policy' exact component={PrivacyPolicy} />
            <Route path='/faqs' exact component={Faqs} />
            <Route path='/contacts' exact component={ContactTwo} />

             
            {/* <Route path='/shop' exact component={ShopGrid} />*/}
            {/* <Route path='/register' exact component={Register} /> */}
            {/* <Route path='/empty-cart' exact component={EmptyCarts} />
            <Route path='/checkout-one' exact component={CheckoutOne} />
            <Route path='/checkout-two' exact component={CheckoutTwos} />
            <Route path='/wishlist' exact component={WishLists} /> */}
            
            {/* <ProtectedRoute path='/order-complete' exact component={OrderComplete} />
            <ProtectedRoute path='/order-tracking' exact component={OrderTracking} /> */}
            
           {/* <ProtectedRoute path='/appointments' exact component={Appointments} />
           <ProtectedRoute path='/profile' exact component={Profile} /> */}
            {/* <Route path='/blog-grid-two' exact component={BlogGridTwos} /> */}

            

            {/* <ProtectedRoute path='/my-account' exact component={MyAccounts}  />
            <ProtectedRoute path='/my-account/customer-order' exact component={CustomerOrder} />
            <ProtectedRoute path='/my-account/customer-download' exact component={CustomerDownloads} />
            <ProtectedRoute path='/my-account/customer-address' exact component={CustomerAddress} />
            <ProtectedRoute path='/my-account/customer-account-details' exact component={CustomerAccountDetails} />
            <ProtectedRoute path='/account-edit' exact component={AccountEdit} /> */}
            {/* <Route path='/login' exact component={Login} /> */}
            
            <Route exact component={Error} />

             {/* <Route path='/product-hover' exact component={ProductHover} />
            <Route path='/order-success' exact component={OrderSuccesses} />
            <Route path='/email-template-one' exact component={EmailTemplateOnes} />
            <Route path='/email-template-two' exact component={EmailTemplateTwos} />
            <Route path='/email-template-three' exact component={EmailTemplateThrees} />
            <Route path='/invoice-one' exact component={InvoiceOne} />
            <Route path='/invoice-two' exact component={InvoiceTwo} /> 
              <Route path='/shopTwo' exact component={ShopTwo} />
            <Route path='/shoplist' exact component={ShopList} />
            
            <Route path='/shop-right-bar' exact component={ShopRightSideBar} />
            */}
          </Switch>
          <Footer />
        </Router>
      </BrowserRouter>

    </>
  );

  function ProtectedRoute ({ component: Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated() ? (
            <Component {...props} /> 
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

    /* function PublicRoute({ component: Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated() ? (
            <Redirect to={{ pathname: "/" }} />
          ) : (
            <Component {...props} /> 
          )
        }
      />
    );
  } */

}

